module.exports = __webpack_public_path__ + "media/images/iconRight__okGreen--dark-75c27eab45be1d775e0a64f692f67f4f.png";